export const NotificationTabs = [
  { type: 'all', label: 'All' },
  { type: 'appointments', label: 'Appointments' },
  { type: 'education', label: 'Read education' },
  { type: 'conversation', label: 'Conversation' },
  // { type: 'messages', label: 'Messages' },
];
